import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { BsCaretDownFill, BsCaretRightFill } from 'react-icons/bs';
import { BookingRequestsService } from '../../../api';
import { bookingRequestsQueryKeys } from '../../query-keys-factories/booking-requests';
import { HistoryItemCard } from './HistoryItemCard';

interface BookingRequestHistoryProps {
  bookingRequestId: string;
}

export const BookingRequestHistory = ({ bookingRequestId }: BookingRequestHistoryProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const {
    data: history,
    isLoading,
    error,
  } = useQuery({
    queryKey: bookingRequestsQueryKeys.history({
      requestId: bookingRequestId,
      limit: 50,
      offset: 0,
    }),
    queryFn: () =>
      BookingRequestsService.bookingRequestsHistoryList({
        requestId: bookingRequestId,
        limit: 50,
        offset: 0,
      }),
  });

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      toggleExpanded();
    }
  };

  return (
    <div className="border-top pt-3">
      <button
        type="button"
        onClick={toggleExpanded}
        onKeyDown={handleKeyDown}
        className="d-flex align-items-center text-section-name--dark-brand mb-3 border-0 bg-transparent h5 p-0"
      >
        {isExpanded ? <BsCaretDownFill className="me-2" /> : <BsCaretRightFill className="me-2" />}
        History
      </button>

      {isExpanded && (
        <div className="history-content">
          {isLoading && <Spinner />}

          {error instanceof Error && (
            <div className="alert alert-danger" role="alert">
              Error loading history. Please try again later.
            </div>
          )}

          {!isLoading && !error && history?.count === 0 && (
            <p className="text-muted">No history found</p>
          )}

          {!isLoading &&
            !error &&
            history?.results?.map((historyItem) => (
              <HistoryItemCard key={historyItem.id} historyItem={historyItem} />
            ))}
        </div>
      )}
    </div>
  );
};
